<lib-suivi-demandes [configuration]="configuration" (onUpdateStatusEvent) = 'handleUpdateStatusEvent($event)' (onEmitUnreadNotificationsEvent)="handleEmitTotalElementEvent($event)"></lib-suivi-demandes>
